export enum InvoiceStatusEnum {
  INVOICED = 'INVOICED',
  OVERDUE = 'OVERDUE',
  PAID = 'PAID',
  PAYMENT_FAILED = 'PAYMENT_FAILED',
  VOIDED = 'VOIDED',
  EXTERNALLY_MANAGED = 'EXTERNALLY_MANAGED',
}

export enum ExternalPayerType {
  EXTERNAL_PAYER_TYPE_UNKNOWN = 'EXTERNAL_PAYER_TYPE_UNKNOWN',
  EXTERNAL_PAYER_TYPE_ACTIVATE_USER = 'EXTERNAL_PAYER_TYPE_ACTIVATE_USER',
  EXTERNAL_PAYER_TYPE_ACTIVATE_COMPANY = 'EXTERNAL_PAYER_TYPE_ACTIVATE_COMPANY',
}

export interface InvoiceeInfo {
  _id: string;
  name: string;
  type: ExternalPayerType;
}
